import {useTranslation} from "react-i18next";
import '../Privacy.css'

const RunLordPrivacy = () => {
    const { t } = useTranslation();
    const sections = t('privacy.run_lord.sections', { returnObjects: true });

    return (
        <div className="privacy-container">
            <h1>{t('privacy.run_lord.title')}</h1>

            <p className="effective-date">{t('privacy.run_lord.last_updated')}</p>
            <p>{t('privacy.run_lord.intro')}</p>

            {sections.map((section) => (
                <section key={section.title}>
                    <h2>{section.title}</h2>
                    {section.body && <p>{section.body}</p>}
                    {section.items && (
                        <ul>
                            {section.items.map((item) => (
                                <li key={item}>{item}</li>
                            ))}
                        </ul>
                    )}
                </section>
            ))}

            <p>develop@persnormal.com</p>
        </div>
    );
}

export default RunLordPrivacy;
